import { Text } from "@fluentui/react"
import { Page } from "../../components/page"

export const VehicleList: React.FunctionComponent<{}> = () => {
    return (
        <Page title="Vehicles">
            <Text>Under construction. Please check back later.</Text>
        </Page>
    )
}